var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerRequisitionDeliveryUnassigned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 52,
    viewBox: "0 0 30 52",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.0776014 0c.5663335 0 1.047717.19821674 1.4441505.59465021s.5946502.87781697.5946502 1.4441505v4.99000587h2.8348031c.9061336 0 1.5291005.42475015 1.8689006 1.27425045.3398001.84950029.1982168 1.58573388-.4247501 2.20870077l-2.6227803 2.622564c5.4188807 2.2285549 9.2274246 7.5001003 9.2274246 13.6482869 0 5.4428062-5 13.8486033-15 25.2173913-10-11.368788-15-19.7745851-15-25.2173913 0-6.1481866 3.80854391-11.419732 9.22742459-13.6482869l-2.62278026-2.622564c-.62296689-.62296689-.76455027-1.35920048-.42475015-2.20870077.33980012-.8495003.962767-1.27425045 1.86890065-1.27425045h2.83480307v-4.99000587c0-.56633353.1982167-1.04771703.5946502-1.4441505s.877817-.59465021 1.4441505-.59465021z",
    fill: "#f2ae00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 27,
    fill: "#1f5bc0",
    r: 11,
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRequisitionDeliveryUnassigned);
export default __webpack_public_path__ + "static/media/map-marker-requisition-delivery-unassigned.12582367daf7da1a7bfdc4b192a6408c.svg";
export { ForwardRef as ReactComponent };